import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ConfirmNotificationPayload } from './types';

export interface ConfirmNotificationState {
    headerText: string;
    contentText: string;
    crosspage?: boolean;
}

const initialState: ConfirmNotificationState = {
    headerText: '',
    contentText: '',
};

const confirmNotificationSlice = createSlice({
    name: 'confirmNotification',
    initialState,
    reducers: {
        setConfirmNotificationData(state: ConfirmNotificationState, action: PayloadAction<ConfirmNotificationPayload>) {
            state.headerText = action.payload.headerText;
            state.contentText = action.payload.contentText;
            state.crosspage = action.payload.crosspage;
        },
        resetConfirmNotificationData(state: ConfirmNotificationState) {
            state.headerText = '';
            state.contentText = '';
        },
    },
});

export const openConfirmNotificationAction = createAction<ConfirmNotificationPayload>('confirmNotification/open');
export const closeConfirmNotificationAction = createAction('confirmNotification/close');

export const { setConfirmNotificationData, resetConfirmNotificationData } = confirmNotificationSlice.actions;

export const confirmNotificationReducer = confirmNotificationSlice.reducer;
